import React, { useState } from 'react';

export function DateInput({ style, value, onChange }) {
  const [error, setError] = useState('');

  function handleBlur(e) {
    const val = e.target.value;
    if (!val) { setError(''); return; }
    const year = parseInt(val.split('-')[0], 10);
    if (year < 1000) {
      onChange('');
      setError('Please enter a 4-digit year.');
    } else {
      setError('');
    }
  }

  return (
    <div>
      <input
        type="date"
        style={{ ...style, ...(error ? { borderColor: '#c0392b' } : {}) }}
        value={value}
        onChange={e => { setError(''); onChange(e.target.value); }}
        onBlur={handleBlur}
      />
      {error && (
        <div style={{ fontSize: 12, color: '#c0392b', marginTop: 4 }}>{error}</div>
      )}
    </div>
  );
}

export const lbl = {
  display: 'block',
  fontSize: 11,
  fontWeight: 700,
  color: '#1a3364',
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  marginBottom: 5,
};

export const inp = {
  width: '100%',
  padding: '10px 12px',
  border: '1.5px solid #c5d5e8',
  borderRadius: 8,
  fontSize: 15,
  color: '#1a3364',
  background: '#fff',
  outline: 'none',
  display: 'block',
};

export const row2 = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 14,
  marginBottom: 18,
};

export const row3 = {
  display: 'grid',
  gridTemplateColumns: '2fr 1.5fr 2fr',
  gap: 14,
  marginBottom: 18,
};

export const sectionDivider = {
  borderTop: '1.5px solid #dbeef8',
  paddingTop: 20,
  marginBottom: 20,
};

export const sectionHeading = {
  fontSize: 13,
  fontWeight: 700,
  color: '#1a3364',
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  marginBottom: 14,
};
